export default __webpack_public_path__ + "static/media/src_img_11.a5f8e617.png";